angular.module("digitalLeasing.module").component("vendorPaymentDetail", {
  templateUrl: "ng/components/digitalLeasing/leasingHypothesis/vendorPaymentDetail/vendorPaymentDetail.view.html",
  bindings: {
    model: '=',
    vendor: '<',
    onSupplierChanges: '&',
    productType: "<",
    listOfSupplier: '<',
    import: '<',
    baseValidation: '<',
    vendorIsOk: '&',
    vendorIsNotOk: '&',
    infoCespite: '=',
    cespiteToAdd: "=",
    snapshot: '<',
    customer: "=",
    regimeApplicabile: "<",
    initialTabIndex: "=",
    cdu: "<",
    allestimento: "<",
    exportCf: "&"
  },
  controllerAs: "VendorPaymentDetailCtrl",
  controller: VendorPaymentDetailController
});

function VendorPaymentDetailController(
  Tranche,
  $scope,
  $timeout,
  $rootScope,
  $configService,
  $userService,
  Fornitore,
  $giuridicVersion
) {
  var self = this;
  self.$rootScope = $rootScope;
  self.$configService = $configService;
  self.supportModel = {
    resume: true,
    resumeBaseValidation: true,
    vendorName: null,
    populatedVendorName: null,
    modality: self.listOfSupplier || [],
    subjectReturned: false,
    searchedSubject: "",
    mode: "",
    temp: [],
    options: ["AZIENDA", "PERSONA"],
    defaultOptions: "AZIENDA",
    optionsIsChanged: false,
    initialIndex: 0,
    cduWithoutCheck: false,
    impostaDiRegistro: false,
    listaFornitori: [],
    fornitore: null
  };

  self.$onInit = function () {
    self.importo = 0;
    self.errorDilazione = [];
    self.numberOfTranches = [2, 3, 4];
    self.tranche = [];
    self.modello = "";
    self.model.delay = 0;
    var controllo = 1;
    self.providerType = "F";
    if (self.vendor.reteVendita == 4) {
      callRelatedProvidersRest();
    }
    if (self.infoCespite) {
      if (self.vendor.reteVendita == 4) {
        const accontiCompensazione = self.cespiteToAdd.fornitore.accontiCompensazione;
        self.cespiteToAdd.fornitore = self.model.preventivo.fornitore;
        self.cespiteToAdd.fornitore.accontiCompensazione = accontiCompensazione;
      }
      self.supportModel.initialIndex = self.initialTabIndex || 0;
      self.isTranches = self.cespiteToAdd.fornitore.modPagamento.tranches;
      var numberOfTranch = self.cespiteToAdd.fornitore.modPagamento.listaTranches.length ? self.cespiteToAdd.fornitore.modPagamento.listaTranches.length : 1;

      if (self.cespiteToAdd.fornitore.modPagamento.listaTranches.length && self.cespiteToAdd.fornitore.modPagamento.listaTranches[0]) {
        self.tranche = self.cespiteToAdd.fornitore.modPagamento.listaTranches;
        self.supportModel.temp = JSON.parse(JSON.stringify(self.cespiteToAdd.fornitore.modPagamento.listaTranches));
        self.tranchesNumber = numberOfTranch;
        controllo = -99;
      }

      if (self.cespiteToAdd.fornitore.riUserG && (self.cespiteToAdd.fornitore.riUserG.cf || (!self.cespiteToAdd.fornitore.riUserG.cf && self.cespiteToAdd.fornitore.riUserG.ndg)) || (self.cespiteToAdd.fornitore.riUserF && self.cespiteToAdd.fornitore.riUserF.cf)) {
        self.supportModel.subjectReturned = true;
        self.supportModel.searchedSubject = self.cespiteToAdd.fornitore;
      } else {
        self.supportModel.searchedSubject = self.cespiteToAdd.fornitore.cfPiva;
      }

      if (!Boolean(self.supportModel.searchedSubject) && self.cespiteToAdd.fornitore.riUserG) {
        self.supportModel.searchedSubject = self.cespiteToAdd.fornitore;
      }

      if (!self.cespiteToAdd.fornitore.modPagamento.description) {
        self.cespiteToAdd.fornitore.modPagamento = JSON.parse(JSON.stringify(self.model.preventivo.fornitore.modPagamento));
      } else {
        self.supportModel.mode = self.cespiteToAdd.fornitore.modPagamento;
      }

      if (self.cespiteToAdd.immobiliare.regimeApplicabile === "imposta di registro") {
        self.supportModel.options = ["PERSONA"];
        self.supportModel.defaultOptions = "PERSONA";
        self.supportModel.impostaDiRegistro = true;
      }

      self.supportModel.cduWithoutCheck =
        self.cespiteToAdd.codiceCDU === "MALLVE01" || self.cespiteToAdd.codiceCDU === "MALLVE02" ? true : false;

      validationAccordion();
    } else {
      self.isTranches = self.model.preventivo.fornitore.modPagamento.tranches;
      var numberOfTranch = self.model.preventivo.fornitore.modPagamento.listaTranches.length ? self.model.preventivo.fornitore.modPagamento.listaTranches.length : 1;

      if (self.model.preventivo.fornitore.modPagamento.listaTranches.length) {
        self.tranche = self.model.preventivo.fornitore.modPagamento.listaTranches;
        self.supportModel.temp = JSON.parse(JSON.stringify(self.model.preventivo.fornitore.modPagamento.listaTranches));
        self.tranchesNumber = numberOfTranch;
        controllo = -99;
      }
    }

    if (self.snapshot) {
      self.supportModel.mode = self.model.preventivo.fornitore.modPagamento
      return
    }
    self.handleSupplierChange("tranches", numberOfTranch, controllo);

  };

  self.$onChanges = function (changes) {
    if (self.infoCespite) {
      var modPag;
      console.log(changes);

      //se aggiungo un nuovo cespite in M15, prendo i dati delle modPagamento da 
      //self.model.preventivo.fornitore.modPagamento
      if (!self.cespiteToAdd.fornitore.modPagamento.description &&
        self.model.preventivo.fornitore.modPagamento.description) {
        self.cespiteToAdd.fornitore.modPagamento = JSON.parse(JSON.stringify(self.model.preventivo.fornitore.modPagamento));
      }

      if (changes.listOfSupplier && changes.listOfSupplier.currentValue && changes.listOfSupplier.currentValue.length) {
        self.supportModel.modality = self.listOfSupplier || [];
        if (!self.supportModel.resume) {
          self.cespiteToAdd.fornitore.modPagamento = "";
        } else {
          self.supportModel.resume = false;
        }
        modPag = changes.listOfSupplier.currentValue
          .find(function (e) {
            return self.cespiteToAdd.fornitore && self.cespiteToAdd.fornitore.modPagamento && (e.description == self.cespiteToAdd.fornitore.modPagamento.description && e.id == self.cespiteToAdd.fornitore.modPagamento.id)
          })
      }
      if (changes.import && changes.import.currentValue) {
        self.importo = changes.import.currentValue;
        ricalcTranches(self.importo);
      }

      if (changes.baseValidation && changes.baseValidation.currentValue) {
        self.baseValidation = changes.baseValidation.currentValue;
        if (self.tranche.length > 1) {
          //self.tranche = self.supportModel.temp; commento inserito per verificare il corretto funzionamento ed evitare errore mantis 0014318
        } else {
          if (!self.supportModel.resume) {
            self.supportModel.temp[0] = "";
          } else {
            self.supportModel.resume = false;
          }
          self.tranche[0].giorniDilazione = self.supportModel.temp[0] ? self.supportModel.temp[0].giorniDilazione : self.baseValidation.giorniDilazione.consigliato.valore;
          self.handleSupplierChange("delay", self.tranche[0].giorniDilazione, 0);
        }
      }

      if (self.cespiteToAdd.fornitore.modPagamento &&
        self.cespiteToAdd.fornitore.modPagamento.description && typeof modPag != 'undefined' && changes.listOfSupplier && changes.listOfSupplier.currentValue) {
        changes.listOfSupplier.currentValue.forEach(function (element) {
          if (element.selected) {
            self.cespiteToAdd.modPag = element;
            self.supportModel.mode = self.cespiteToAdd.modPag;
          }
        })
        self.handleSupplierChange("modality", self.cespiteToAdd.fornitore.modPagamento);
        return;
      } else if (changes.listOfSupplier && changes.listOfSupplier.currentValue && changes.listOfSupplier.currentValue.length > 0) {

        self.supportModel.mode = changes.listOfSupplier.currentValue
          .find(function (e) {
            return e.selected == true;
          })
        self.cespiteToAdd.fornitore.modPagamento = changes.listOfSupplier.currentValue
          .find(function (e) {
            return e.selected == true;
          })

        self.handleSupplierChange("modality", self.cespiteToAdd.fornitore.modPagamento);
      } else if (self.model.preventivo.fornitore.modPagamento && self.model.preventivo.fornitore.modPagamento.id && self.model.preventivo.fornitore.modPagamento.description) {
        self.supportModel.mode = self.model.preventivo.fornitore.modPagamento;
      }

      if (self.cespiteToAdd.immobiliare.regimeApplicabile === "imposta di registro") {
        self.supportModel.options = ["PERSONA"];
        self.supportModel.defaultOptions = "PERSONA";
        self.supportModel.impostaDiRegistro = true;
      } else {
        self.supportModel.options = ["AZIENDA", "PERSONA"];
        self.supportModel.defaultOptions = "AZIENDA";
        self.supportModel.impostaDiRegistro = false;
      }

      if (changes.regimeApplicabile) {
        self.supportModel.optionsIsChanged = !self.supportModel.optionsIsChanged;
        if (self.cespiteToAdd.immobiliare.regimeApplicabile === "imposta di registro") {
          self.supportModel.options = ["PERSONA"];
          self.supportModel.defaultOptions = "PERSONA";
          self.supportModel.impostaDiRegistro = true;
        } else {
          self.supportModel.options = ["AZIENDA", "PERSONA"];
          self.supportModel.defaultOptions = "AZIENDA";
          self.supportModel.impostaDiRegistro = false;
        }
      }

      if (changes.cdu) {
        self.supportModel.cduWithoutCheck = self.allestimento;
        //self.cespiteToAdd.codiceCDU === "MALLVE01" || self.cespiteToAdd.codiceCDU === "MALLVE02" ? true : false;
        if (self.tranche && self.errorDilazione) {
          self.handleSupplierChange('delay', self.tranche[0].giorniDilazione, 0);
        }
      }

    } else {

      var modPag;
      console.log(changes);
      if (changes.listOfSupplier && changes.listOfSupplier.currentValue && changes.listOfSupplier.currentValue.length) {
        self.supportModel.modality = self.listOfSupplier || [];
        if (!self.supportModel.resume) {
          self.model.preventivo.fornitore.modPagamento = "";
        } else {
          self.supportModel.resume = false;
        }
        modPag = changes.listOfSupplier.currentValue
          .find(function (e) {
            return self.model.preventivo.fornitore && self.model.preventivo.fornitore.modPagamento && (e.description == self.model.preventivo.fornitore.modPagamento.description && e.id == self.model.preventivo.fornitore.modPagamento.id)
          })
      }
      if (changes.import && changes.import.currentValue) {
        self.importo = changes.import.currentValue;
        ricalcTranches(self.importo);
      }

      if (changes.baseValidation && changes.baseValidation.currentValue) {
        self.baseValidation = changes.baseValidation.currentValue;
        if (self.tranche.length > 1) {
          //self.tranche = self.supportModel.temp; commento inserito per verificare il corretto funzionamento ed evitare errore mantis 0014318
        } else {
          if (self.supportModel.resumeBaseValidation) {
            self.supportModel.resumeBaseValidation = false;
          } else {
            self.supportModel.temp[0] = "";
          }
          self.tranche[0].giorniDilazione = self.supportModel.temp[0] ? self.supportModel.temp[0].giorniDilazione : self.baseValidation.result.giorniDilazione.consigliato.valore;
          if (self.tranche[0].giorniDilazione == 0 && self.baseValidation.result.giorniDilazione.consigliato.valore > 0) {
            self.tranche[0].giorniDilazione = self.baseValidation.result.giorniDilazione.consigliato.valore;
          }
          self.handleSupplierChange("delay", self.tranche[0].giorniDilazione, 0);
        }
      }

      if (self.model.preventivo.fornitore.modPagamento &&
        self.model.preventivo.fornitore.modPagamento.description && typeof modPag != 'undefined') {
        self.supportModel.mode = self.model.preventivo.fornitore.modPagamento;
        self.supportModel.mode.listaTranches = self.supportModel.temp;
        self.handleSupplierChange("modality", self.model.preventivo.fornitore.modPagamento);
        return;
      } else if (changes.listOfSupplier && changes.listOfSupplier.currentValue && changes.listOfSupplier.currentValue.length > 0) {

        self.supportModel.mode = changes.listOfSupplier.currentValue
          .find(function (e) {
            return e.selected == true;
          })
        self.model.preventivo.fornitore.modPagamento = changes.listOfSupplier.currentValue
          .find(function (e) {
            return e.selected == true;
          })

        self.handleSupplierChange("modality", self.supportModel.mode);
      }
    }

  }

  self.enableNextButton = function () {
    if (self.model.modality) {
      self.onModalityChanges();
    }
  };

  self.handleSupplierChange = function (property, value, index) {
    if (self.snapshot) {
      return;
    }

    if (self.infoCespite) {
      self.baseValidation = self.model.preventivo.validations;
    }
    switch (property) {
      case "modality":
        if (self.infoCespite) {
          if (!value) {
            value = {
              id: null,
              tranches: null
            }
          }
          self.cespiteToAdd.fornitore.modPagamento = value;
          //TODO workaround per mantis n. 0015751
          //se cambio la mod. pagamento e poi rimetto quella iniziale, le traches sono erroneamente a true 
          if (value.id == self.model.preventivo.fornitore.modPagamento.id) {
            self.cespiteToAdd.fornitore.modPagamento.id = self.model.preventivo.fornitore.modPagamento.id;
            self.cespiteToAdd.fornitore.modPagamento.description = self.model.preventivo.fornitore.modPagamento.description;
            self.cespiteToAdd.fornitore.modPagamento.selected = self.model.preventivo.fornitore.modPagamento.selected;
            self.cespiteToAdd.fornitore.modPagamento.tranches = self.model.preventivo.fornitore.modPagamento.tranches;
            self.cespiteToAdd.fornitore.modPagamento.usato = self.model.preventivo.fornitore.modPagamento.usato;
          }
          self.importo = self.cespiteToAdd.importoCespite;
          self.tranchesNumber = (self.cespiteToAdd.fornitore && self.cespiteToAdd.fornitore.modPagamento && self.cespiteToAdd.fornitore.modPagamento.listaTranches) ? self.cespiteToAdd.fornitore.modPagamento.listaTranches.length : "";
          if (self.tranchesNumber == 1) {
            self.tranchesNumber = ""
          }
          if (!value.tranches) {
            self.tranche = [];

            self.tranche.push(Tranche.build({
              importoPagamento: self.cespiteToAdd.importoCespite,
              percentualePagamento: 100,
              giorniDilazione: (self.cespiteToAdd.fornitore.modPagamento.listaTranches && self.cespiteToAdd.fornitore.modPagamento.listaTranches[0]) ? self.cespiteToAdd.fornitore.modPagamento.listaTranches[0].giorniDilazione : ((self.baseValidation && self.baseValidation.giorniDilazione && self.baseValidation.giorniDilazione.consigliato && self.baseValidation.giorniDilazione.consigliato.valore) ? self.baseValidation.giorniDilazione.consigliato.valore : 0)
            }));
            self.cespiteToAdd.fornitore.modPagamento.listaTranches = self.tranche;
            var value = self.cespiteToAdd.fornitore.modPagamento.listaTranches[0].giorniDilazione;
            checkTranch(0, value);
          } else {
            if (typeof value.id != "undefined") {
              self.tranche = [];
              if (self.cespiteToAdd.fornitore.modPagamento && self.cespiteToAdd.fornitore.modPagamento.listaTranches) {
                self.cespiteToAdd.fornitore.modPagamento.listaTranches.forEach(function (element) {
                  self.tranche.push(Tranche.build({
                    importoPagamento: element.importoPagamento,
                    percentualePagamento: element.percentualePagamento,
                    giorniDilazione: element.giorniDilazione
                  }));
                });
              }
            } else {
              self.tranchesNumber = 2;
              self.handleSupplierChange('tranches', 2);
            }
          }

        } else {
          self.model.preventivo.fornitore.modPagamento = value;
          self.importo = self.model.preventivo.importo;
          self.tranchesNumber = self.model.preventivo.fornitore.modPagamento.listaTranches ? self.model.preventivo.fornitore.modPagamento.listaTranches.length : "";
          if (self.tranchesNumber == 1) {
            self.tranchesNumber = ""
          }
          if (!value.tranches) {
            self.tranche = [];

            self.tranche.push(Tranche.build({
              importoPagamento: self.model.preventivo.importo,
              percentualePagamento: 100,
              giorniDilazione: (self.model.preventivo.fornitore.modPagamento.listaTranches && self.model.preventivo.fornitore.modPagamento.listaTranches[0]) ? self.model.preventivo.fornitore.modPagamento.listaTranches[0].giorniDilazione : ((self.baseValidation && self.baseValidation.result && self.baseValidation.result.giorniDilazione && self.baseValidation.result.giorniDilazione.consigliato && self.baseValidation.result.giorniDilazione.consigliato.valore) ? self.baseValidation.result.giorniDilazione.consigliato.valore : 0)
            }));
            self.model.preventivo.fornitore.modPagamento.listaTranches = self.tranche;
            var value = self.model.preventivo.fornitore.modPagamento.listaTranches[0].giorniDilazione;
            checkTranch(0, value);
          } else {
            if (typeof value.id != "undefined") {
              //self.tranchesNumber = value && value.listaTranches && value.listaTranches.length;
            } else {
              self.tranchesNumber = 2;
              self.handleSupplierChange('tranches', 2);
            }
          }
        }
        validationAccordion();
        break;

      case "tranches":
        self.tranche = [];
        if (self.infoCespite) {
          if (index != -99) {
            for (i = 0; i < value; i++) {
              self.tranche.push(Tranche.build({
                importoPagamento: Math.round(self.cespiteToAdd.importoCespite / value * 100) / 100,
                percentualePagamento: Math.round(100 / value * 1000) / 1000,
                giorniDilazione: (self.baseValidation && self.baseValidation.giorniDilazione && self.baseValidation.giorniDilazione.consigliato && self.baseValidation.giorniDilazione.consigliato.valore) ? (self.baseValidation.giorniDilazione.consigliato.valore + i) : 0
              }));
            }
            if (value == 3) {
              var importoTerzaTranche = self.cespiteToAdd.importoCespite - (self.tranche[0].importoPagamento + self.tranche[1].importoPagamento);
              self.tranche[2].importoPagamento = Math.round(importoTerzaTranche * 100) / 100;
              self.tranche[2].percentualePagamento = 100 - (self.tranche[0].percentualePagamento + self.tranche[1].percentualePagamento) //Math.round((100 * importoTerzaTranche / self.model.preventivo.importo) * 1000) / 1000;
            }
            self.cespiteToAdd.fornitore.modPagamento.listaTranches = self.tranche;
          } else {
            self.tranche = self.cespiteToAdd.fornitore.modPagamento.listaTranches;
          }

          if (value > 1) {
            $timeout(function () {
              self.handleSupplierChange('delay', self.tranche[0].giorniDilazione, 0);
            }, 1000)

          }

        } else {
          if (index != -99) {
            for (i = 0; i < value; i++) {
              self.tranche.push(Tranche.build({
                importoPagamento: Math.round(self.model.preventivo.importo / value * 100) / 100,
                percentualePagamento: Math.round(100 / value * 1000) / 1000,
                giorniDilazione: (self.baseValidation && self.baseValidation.result && self.baseValidation.result.giorniDilazione && self.baseValidation.result.giorniDilazione.consigliato && self.baseValidation.result.giorniDilazione.consigliato.valore) ? (self.baseValidation.result.giorniDilazione.consigliato.valore + i) : 0
              }));
            }
            if (value == 3) {
              var importoTerzaTranche = self.model.preventivo.importo - (self.tranche[0].importoPagamento + self.tranche[1].importoPagamento);
              self.tranche[2].importoPagamento = Math.round(importoTerzaTranche * 100) / 100;
              self.tranche[2].percentualePagamento = 100 - (self.tranche[0].percentualePagamento + self.tranche[1].percentualePagamento) //Math.round((100 * importoTerzaTranche / self.model.preventivo.importo) * 1000) / 1000;
            }
            self.model.preventivo.fornitore.modPagamento.listaTranches = self.tranche;
          } else {
            self.tranche = self.model.preventivo.fornitore.modPagamento.listaTranches;
          }

          if (value > 1) {
            $timeout(function () {
              self.handleSupplierChange('delay', self.tranche[0].giorniDilazione, 0);
            }, 1000)

          }
        }

        $timeout(function () {
          validationAccordion();
        }, 2000)
        break;

      case "delay":
        self.mexErrorDilazione = "";
        value = parseInt(value);
        if (self.infoCespite) {
          self.supportModel.cduWithoutCheck = self.allestimento;
          if (self.supportModel.cduWithoutCheck) {
            if (!self.cespiteToAdd.fornitore.modPagamento.tranches) {
              if (value > 999 ||
                value < 0) {
                self.errorDilazione[0] = true;
                $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-0'].$setValidity('dilazione-0', false);
                jQuery('#dilazione-0').addClass('has-error');
                self.mexErrorDilazione = "I giorni di dilazione devono rientrare dentro il range. Min: 0 <br/>Max: 999"
              } else {
                self.errorDilazione[0] = false;
                $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-0'].$setValidity('dilazione-0', true);
                jQuery('#dilazione-0').removeClass('has-error');
              }
            } else {
              checkTranch(index, value);

            }
          } else {
            if (!self.cespiteToAdd.fornitore.modPagamento.tranches) {
              var validateMaxGgDilazione = 0;
              var valueOfMaxGgFromRest = self.listOfSupplier.find(function (element) {
                return element.id == self.cespiteToAdd.fornitore.modPagamento.id
              }) && self.listOfSupplier.find(function (element) {
                return element.id == self.cespiteToAdd.fornitore.modPagamento.id
              }).maxGiorniDilazione
              if ((valueOfMaxGgFromRest != null && valueOfMaxGgFromRest != undefined && typeof valueOfMaxGgFromRest != "undefined") && self.baseValidation.giorniDilazione.massimo.valore > valueOfMaxGgFromRest) {
                validateMaxGgDilazione = valueOfMaxGgFromRest;
              } else {
                validateMaxGgDilazione = self.baseValidation.giorniDilazione.massimo.valore;
              }
              if (value > validateMaxGgDilazione ||
                value < self.baseValidation.giorniDilazione.minimo.valore) {
                self.errorDilazione[0] = true;
                $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-0'].$setValidity('dilazione-0', false);
                jQuery('#dilazione-0').addClass('has-error');
                self.mexErrorDilazione = "I giorni di dilazione devono rientrare dentro il range. Min: " +
                  self.baseValidation.giorniDilazione.minimo.valore + "<br/>Max: " +
                  validateMaxGgDilazione
              } else {
                self.errorDilazione[0] = false;
                $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-0'].$setValidity('dilazione-0', true);
                jQuery('#dilazione-0').removeClass('has-error');
              }
            } else {
              checkTranch(index, value);

            }
          }

          self.tranche[index].giorniDilazione = value;

          self.cespiteToAdd.fornitore.modPagamento.listaTranches = self.tranche;

        } else {

          if (!self.model.preventivo.fornitore.modPagamento.tranches) {
            if (value > self.baseValidation.result.giorniDilazione.massimo.valore ||
              value < self.baseValidation.result.giorniDilazione.minimo.valore) {
              self.errorDilazione[0] = true;
              $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-0'].$setValidity('dilazione-0', false);
              jQuery('#dilazione-0').addClass('has-error');
              self.mexErrorDilazione = "I giorni di dilazione devono rientrare dentro il range. Min: " +
                self.baseValidation.result.giorniDilazione.minimo.valore + "<br/>Max: " +
                self.baseValidation.result.giorniDilazione.massimo.valore
            } else {
              self.errorDilazione[0] = false;
              $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-0'].$setValidity('dilazione-0', true);
              jQuery('#dilazione-0').removeClass('has-error');
            }
          } else {
            var totaleGgDilazioni = 0;
            checkTranch(index, value);

          }
          self.tranche[index].giorniDilazione = value;

          self.model.preventivo.fornitore.modPagamento.listaTranches = self.tranche;

        }
        validationAccordion();

        break;

      case 'importPerc':
        if (self.infoCespite) {
          if (self.tranche[index]) {
            self.cespiteToAdd.fornitore.modPagamento.listaTranches = self.tranche;
            if (value.currency && value.percent && index) {
              self.tranche[index].importoPagamento = value.currency;
              self.tranche[index].percentualePagamento = value.percent;
            } else if (!self.cespiteToAdd.fornitore.modPagamento.tranches && self.model.preventivo.fornitore.modPagamento.listaTranches[0]) {
              self.tranche[0] = self.model.preventivo.fornitore.modPagamento.listaTranches[0];
            }
          }

        } else {

          self.tranche[index].importoPagamento = value.currency;
          self.tranche[index].percentualePagamento = value.percent;
          self.model.preventivo.fornitore.modPagamento.listaTranches = self.tranche;
        }

        validationAccordion();
        break;

      case 'fornitore':
        if (self.infoCespite) { } else {
          value.modPagamento = self.model.preventivo.fornitore.modPagamento
          self.model.preventivo.fornitore = Fornitore.build(value);
        }
        validationAccordion();

        break;
      case 'identifier':
        validationAccordion();
        break;

      default:
        validationAccordion();
        break;
    }

    if (!self.infoCespite) {
      self.onSupplierChanges({
        supplier: self.model
      });
    }
  };

  self.getSubject = function (subject, value) {
    if (value) {
      switch (subject) {
        case 'subjectReturned':
          self.supportModel.subjectReturned = false;
          self.cespiteToAdd.fornitore.isPersona = false;
          if (value.riUserG) {
            self.cespiteToAdd.fornitore.riUserG = value.riUserG;
            self.supportModel.searchedSubject = value.riUserG.ragioneSociale;
            if (self.validityCustomerDigital) {
              self.supportModel.subjectReturned = true;
            }

            if (!$giuridicVersion.checkIfInd(value.riUserG.formaGiuridica)) {
              self.cespiteToAdd.fornitore.riUserF = null;
            } else {
              self.cespiteToAdd.fornitore.riUserF = value.riUserF;
            }
          }
          if (value.riUserF && !value.riUserG) {
            self.cespiteToAdd.fornitore.isPersona = true;
            self.cespiteToAdd.fornitore.riUserF = value.riUserF;
            if (self.validityCustomerDigital) {
              self.supportModel.subjectReturned = true;
            }
            self.cespiteToAdd.fornitore.riUserG = null;
          }

          break;

        default:
          self.cespiteToAdd.fornitore[subject] = value;
          break;
      }
    }

    validationAccordion();
  }

  var validationAccordion = function () {
    var totaleImportoTranche = 0;

    if (self.infoCespite) {
      var test = false;
      var testListaTrhaches = false;

      if (self.cespiteToAdd && self.cespiteToAdd.fornitore) {
        self.cespiteToAdd.fornitore.modPagamento.listaTranches && self.cespiteToAdd.fornitore.modPagamento.listaTranches[0] && self.cespiteToAdd.fornitore.modPagamento.listaTranches
          .forEach(function (element) {
            totaleImportoTranche = totaleImportoTranche + parseFloat(element.importoPagamento);
          });

        if (self.vendor.reteVendita == 4) {
          self.validityCustomerDigital = true;
        }

        test = !!self.cespiteToAdd.fornitore.modPagamento.id &&
          self.supportModel.subjectReturned &&
          self.validityCustomerDigital &&
          (self.cespiteToAdd.fornitore.riUserG || self.cespiteToAdd.fornitore.riUserF)

        if (self.cespiteToAdd.fornitore.modPagamento.listaTranches &&
          self.cespiteToAdd.fornitore.modPagamento.listaTranches.length && self.cespiteToAdd.fornitore.modPagamento.listaTranches[0]) {
          var testListaTrhaches = self.cespiteToAdd.fornitore.modPagamento.listaTranches[0].giorniDilazione != null &&
            !!self.cespiteToAdd.fornitore.modPagamento.listaTranches[0].importoPagamento &&
            !!self.cespiteToAdd.fornitore.modPagamento.listaTranches[0].percentualePagamento &&
            (totaleImportoTranche == self.cespiteToAdd.importoCespite);
        } else {
          testListaTrhaches = true;
        }

        if (totaleImportoTranche != parseFloat(self.cespiteToAdd.importoCespite)) {
          self.enableErrorTotalImport = true;
        } else {
          self.enableErrorTotalImport = false;
        }

      } else {
        test = self.model.preventivo.prodotto.beneContratto[0].fornitore.modPagamento.id &&
          self.validityCustomerDigital &&
          (self.model.preventivo.prodotto.beneContratto[0].fornitore.riUserG ||
            self.model.preventivo.prodotto.beneContratto[0].fornitore.riUserF);

        testListaTrhaches = true;
      }
      //M5
    } else {
      self.model.preventivo.fornitore.modPagamento.listaTranches && self.model.preventivo.fornitore.modPagamento.listaTranches
        .forEach(function (element) {
          totaleImportoTranche = totaleImportoTranche + element.importoPagamento;
        })

      var test = ($scope.formVendorPaymentDetail &&
        $scope.formVendorPaymentDetail.$valid) &&
        !!self.model.preventivo.fornitore.modPagamento.id &&
        (totaleImportoTranche == self.model.preventivo.importo);

      var testListaTrhaches = true;

      if (totaleImportoTranche != parseFloat(self.model.preventivo.importo)) {
        self.enableErrorTotalImport = true;
      } else {
        self.enableErrorTotalImport = false;
      }

      if (self.vendor.reteVendita == 4) {
        test = test && !!self.model.preventivo.fornitore.riUserG.ragioneSociale
      }
    }

    if (test && testListaTrhaches && !self.enableErrorTotalImport &&
      $scope.formVendorPaymentDetail && !$scope.formVendorPaymentDetail.$invalid) {
      self.vendorIsOk();
    } else {
      self.vendorIsNotOk();
    }
  }

  self.exportValidityCustomerDigital = function (validity) {
    self.validityCustomerDigital = validity;
    validationAccordion();
  }

  var ricalcTranches = function (value) {
    var importo = parseFloat(value);
    var numeroTranches = self.model.preventivo.fornitore.modPagamento.listaTranches.length;
    var listToEvaluate = [];

    if (self.infoCespite) {
      if (self.cespiteToAdd.fornitore.modPagamento.listaTranches.length && self.cespiteToAdd.fornitore.modPagamento.listaTranches[0]) {
        self.cespiteToAdd.fornitore.modPagamento.listaTranches.forEach(function (element) {
          if (element.percentualePagamento == 0) {
            element.percentualePagamento = Math.round(100 / self.cespiteToAdd.fornitore.modPagamento.listaTranches.length);
          }
        });
        listToEvaluate = self.cespiteToAdd.fornitore.modPagamento.listaTranches;
      }
    } else if (self.model.preventivo.fornitore.modPagamento.listaTranches.length && self.model.preventivo.fornitore.modPagamento.listaTranches[0]) {
      listToEvaluate = self.model.preventivo.fornitore.modPagamento.listaTranches;
    }

    listToEvaluate.forEach(function (element) {
      if (listToEvaluate.length == 1) {
        element.percentualePagamento = 100;
      }
      const percPagamentoTemp = element.percentualePagamento
      element.importoPagamento = Math.round((importo * percPagamentoTemp / 100) * 100) / 100;
      element.percentualePagamento = percPagamentoTemp;
    })
    self.model.preventivo.fornitore.modPagamento.listaTranches = listToEvaluate;
  }

  var checkTranch = function (indexOfinsert, valueInsert) {
    var ordinata = self.tranche
      .map(function (element) {
        return parseInt(element.giorniDilazione)
      }).sort(function (a, b) {
        if (a > b) {
          return 1
        } else {
          return -1
        }
      })
    var tranche = self.tranche
      .map(function (element) {
        return parseInt(element.giorniDilazione)
      })
    var totaleGgDilazioni = self.tranche
      .map(function (element) {
        return element.giorniDilazione
      })
      .reduce(function (total, currentValue) {
        return total + currentValue
      })

    if (self.infoCespite) {
      if (typeof self.errorDilazione === "undefined") {
        self.errorDilazione = [];
      }
      if (self.supportModel.cduWithoutCheck) {
        if (self.tranche[indexOfinsert].giorniDilazione > 999 ||
          self.tranche[indexOfinsert].giorniDilazione < 0) {
          self.errorDilazione[indexOfinsert] = true;
          $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + indexOfinsert].$setValidity('dilazione-' + indexOfinsert, false);
          jQuery('#dilazione-' + indexOfinsert).addClass('has-error');
          self.isInvalidForBaseValidation = true;
          self.mexErrorDilazione = "I giorni di dilazione devono rientrare dentro il range. Min: 0<br/>Max: 999"

        } else {
          self.errorDilazione[indexOfinsert] = false;
          $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + indexOfinsert].$setValidity('dilazione-' + indexOfinsert, true);
          jQuery('#dilazione-' + indexOfinsert).removeClass('has-error');

        }
      } else {
        if (self.baseValidation && (self.tranche[indexOfinsert].giorniDilazione > self.baseValidation.giorniDilazione.massimo.valore ||
          self.tranche[indexOfinsert].giorniDilazione < self.baseValidation.giorniDilazione.minimo.valore)) {
          self.errorDilazione[indexOfinsert] = true;
          $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + indexOfinsert].$setValidity('dilazione-' + indexOfinsert, false);
          jQuery('#dilazione-' + indexOfinsert).addClass('has-error');
          self.isInvalidForBaseValidation = true;
          self.mexErrorDilazione = "I giorni di dilazione devono rientrare dentro il range. Min: " +
            self.baseValidation.giorniDilazione.minimo.valore + "<br/>Max: " +
            self.baseValidation.giorniDilazione.massimo.valore

        } else {
          self.errorDilazione[indexOfinsert] = false;
          $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + indexOfinsert].$setValidity('dilazione-' + indexOfinsert, true);
          jQuery('#dilazione-' + indexOfinsert).removeClass('has-error');

        }
      }
    } else {
      if (self.baseValidation && (self.tranche[indexOfinsert].giorniDilazione > self.baseValidation.result.giorniDilazione.massimo.valore ||
        self.tranche[indexOfinsert].giorniDilazione < self.baseValidation.result.giorniDilazione.minimo.valore)) {
        self.errorDilazione[indexOfinsert] = true;
        $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + indexOfinsert].$setValidity('dilazione-' + indexOfinsert, false);
        jQuery('#dilazione-' + indexOfinsert).addClass('has-error');
        self.isInvalidForBaseValidation = true;
        self.mexErrorDilazione = "I giorni di dilazione devono rientrare dentro il range. Min: " +
          self.baseValidation.result.giorniDilazione.minimo.valore + "<br/>Max: " +
          self.baseValidation.result.giorniDilazione.massimo.valore

      } else {
        self.errorDilazione[indexOfinsert] = false;
        $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + indexOfinsert].$setValidity('dilazione-' + indexOfinsert, true);
        jQuery('#dilazione-' + indexOfinsert).removeClass('has-error');

      }
    }

    for (i = 0; i < ordinata.length; i++) {
      var index = i;
      if (tranche[i] != ordinata[i]) {
        self.errorDilazione[indexOfinsert] = true;
        self.mexErrorDilazione = "Le tranches devono avere giorni dilazione sempre diversi e crescenti";
        $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + indexOfinsert].$setValidity('dilazione-' + indexOfinsert, false);
        jQuery('#dilazione-' + indexOfinsert).addClass('has-error');
        break;
      } else if (index != indexOfinsert) {
        if (self.tranche[index].giorniDilazione == valueInsert) {
          self.errorDilazione[indexOfinsert] = true;
          self.mexErrorDilazione = "Le tranches devono avere giorni dilazione sempre diversi e crescenti"
          $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + indexOfinsert].$setValidity('dilazione-' + indexOfinsert, false);
          jQuery('#dilazione-' + indexOfinsert).addClass('has-error');
          self.errorDilazione[index] = true;
          self.mexErrorDilazione = "Le tranches devono avere giorni dilazione sempre diversi e crescenti"
          $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + index].$setValidity('dilazione-' + index, false);
          jQuery('#dilazione-' + index).addClass('has-error');
          break;
        } else {
          if (self.infoCespite) {
            if (self.supportModel.cduWithoutCheck) {
              if (self.tranche[index].giorniDilazione > 999 ||
                self.tranche[index].giorniDilazione < 0) {
                self.errorDilazione[index] = true;
                $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + index].$setValidity('dilazione-' + index, false);
                jQuery('#dilazione-' + index).addClass('has-error');
                self.isInvalidForBaseValidation = true;
                self.mexErrorDilazione = "I giorni di dilazione devono rientrare dentro il range. Min: " +
                  self.baseValidation.giorniDilazione.minimo.valore + "<br/>Max: " +
                  self.baseValidation.giorniDilazione.massimo.valore

              } else {
                self.errorDilazione[index] = false;
                $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + index].$setValidity('dilazione-' + index, true);
                jQuery('#dilazione-' + index).removeClass('has-error');

              }
            } else {
              if (self.baseValidation && (self.tranche[index].giorniDilazione > self.baseValidation.giorniDilazione.massimo.valore ||
                self.tranche[index].giorniDilazione < self.baseValidation.giorniDilazione.minimo.valore)) {
                self.errorDilazione[index] = true;
                $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + index].$setValidity('dilazione-' + index, false);
                jQuery('#dilazione-' + index).addClass('has-error');
                self.isInvalidForBaseValidation = true;
                self.mexErrorDilazione = "I giorni di dilazione devono rientrare dentro il range. Min: " +
                  self.baseValidation.giorniDilazione.minimo.valore + "<br/>Max: " +
                  self.baseValidation.giorniDilazione.massimo.valore

              } else {
                self.errorDilazione[index] = false;
                $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + index].$setValidity('dilazione-' + index, true);
                jQuery('#dilazione-' + index).removeClass('has-error');

              }
            }
          } else {
            if (self.baseValidation && (self.tranche[index].giorniDilazione > self.baseValidation.result.giorniDilazione.massimo.valore ||
              self.tranche[index].giorniDilazione < self.baseValidation.result.giorniDilazione.minimo.valore)) {
              self.errorDilazione[index] = true;
              $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + index].$setValidity('dilazione-' + index, false);
              jQuery('#dilazione-' + index).addClass('has-error');
              self.isInvalidForBaseValidation = true;
              self.mexErrorDilazione = "I giorni di dilazione devono rientrare dentro il range. Min: " +
                self.baseValidation.result.giorniDilazione.minimo.valore + "<br/>Max: " +
                self.baseValidation.result.giorniDilazione.massimo.valore

            } else {
              self.errorDilazione[index] = false;
              $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + index].$setValidity('dilazione-' + index, true);
              jQuery('#dilazione-' + index).removeClass('has-error');

            }
          }
        }

      } else {
        if (self.isInvalidForBaseValidation) {
          self.isInvalidForBaseValidation = false;
          return;
        }
        self.errorDilazione[index] = false;
        $scope.formVendorPaymentDetail && $scope.formVendorPaymentDetail['dilazione-' + index].$setValidity('dilazione-' + index, true);
        jQuery('#dilazione-' + index).removeClass('has-error');

      }
    }
  }

  var callRelatedProvidersRest = function () {
    $userService.relProviders(self.vendor.riUserG.ndg)
      .then(function (response) {
        self.supportModel.listaFornitori = response.providers
        if (self.model.preventivo.fornitore.riUserG.ndg) {
          self.supportModel.fornitore = Fornitore.build(self.model.preventivo.fornitore)
        }
      })
  }

  self.modifyFornitoreReteQuat = function (value) {
    console.log(self.cespiteToAdd);
    var modalitaPagamento = self.cespiteToAdd.fornitore.modPagamento;
    self.cespiteToAdd.fornitore = value;
    self.cespiteToAdd.fornitore.modPagamento = modalitaPagamento

  }
  self.cfFunction = function (input) {
    self.exportCf({
      value: input
    });
  }
}